import type { ReactNode } from 'react';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import { useTranslation } from 'react-i18next';
import { StatusPage } from './StatusPage';

/**
 * Replaces the legacy coarse `ui.*` entry gate (Addendum A.2): the shell requires at least one
 * module manifest to grant *something*, otherwise this page — instead of an empty console the
 * user cannot explain.
 */
export function NoAccessPage(): ReactNode {
  const { t } = useTranslation('shell');
  return (
    <StatusPage
      icon={<InboxOutlinedIcon fontSize="large" />}
      title={t('noAccess.title')}
      description={t('noAccess.description')}
    />
  );
}
